import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/lib/guards';

/**
 * Layout route for /locations/:locId/*. Renders <Outlet /> so the `/edit`
 * child can mount alongside the index detail. Same layout pattern Modules
 * 1 + 2 needed for $id routes with edit children.
 */
export const Route = createFileRoute(
  '/_staff/admin/workspace/organizations/$orgId/locations/$locId',
)({
  beforeLoad: () => {
    requirePermission('location:read');
  },
  component: WorkspaceLocationLayout,
  staticData: { crumb: 'Location' },
});

function WorkspaceLocationLayout() {
  return <Outlet />;
}
